import { useTranslation } from 'react-i18next';
import { Stack, Switch } from '@mantine/core';

import { useSoundSettings } from './sounds';

export function SoundSettings() {
    const { t } = useTranslation('reactions');
    const { reactions, raisedHand, setReactions, setRaisedHand } = useSoundSettings();

    return (
        <Stack gap="sm">
            <Switch
                checked={reactions}
                label={t('sounds.reactions')}
                onChange={(event) => {
                    setReactions(event.currentTarget.checked);
                }}
            />
            <Switch
                checked={raisedHand}
                label={t('sounds.raisedHand')}
                onChange={(event) => {
                    setRaisedHand(event.currentTarget.checked);
                }}
            />
        </Stack>
    );
}
